import React from 'react'

const SvgUserReturn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.412 14c.205 0 .719.082.506.47-.141.259-.508.769-1.1 1.53H8c-2.667 0-4 1.333-4 4h7.208c1.086.96 1.593 1.523 1.52 1.692-.11.254-.27.308-.61.308H4c-1.333 0-2-.667-2-2 0-4 2.001-6 6.004-6h2.408zm7.3-.379c.354.355.368.925.051 1.327l-.086.097-.956.955h.719l1.887.001h1.852c.6 0 .821.529.821 1 0 .278 0 .999-.82.997H18.06L16.154 18l1.42 1.42c.354.355.369.925.052 1.328l-.086.097c-.371.372-.943.413-1.331.115l-.093-.081-2.831-2.831c-.355-.355-.369-.925-.052-1.328l.086-.097 2.968-2.968c.403-.402 1.04-.418 1.424-.034zM12 2a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z'
    />
  </svg>
)

export default SvgUserReturn
